<template>
    <el-container class="ysxkLpbShowmorexx">
        <el-main>
            <el-breadcrumb separator-class="el-icon-arrow-right" >
                <el-breadcrumb-item class="headTitle">当前位置：</el-breadcrumb-item>
                <el-breadcrumb-item class="secondTitle">商品房</el-breadcrumb-item>
                <el-breadcrumb-item class="secondTitle">预售项目详情</el-breadcrumb-item>
                <el-breadcrumb-item class="ThirdTitle">楼盘表</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="mainCard">
                <el-card class="box-card el-headCard" shadow="never">
                    <div slot="header" class="clearfix">
                        <el-col :span="5">
                            <div class="headSecond">{{xmMap.XQMC}}</div>
                            <div class="headThree">{{xmMap.LH}}-{{floorList.ZMJ}}㎡/{{floorList.ZTS}}套</div>
                        </el-col>
                        <el-col :span="19">
                            <el-col :span="4"   :style="{background: item.COLOR}"  :class="item.FWTYPESX"   v-for="item in lpbLxList" class="lplxDiv">
                                <el-row>
                                        <span class="fwlx">
                                        {{item.FWTYPE}}
                                    </span>
                                </el-row>
                                <el-row>
                                        <span class="fwtsmj">
                                        {{item.TS}}套/{{item.MJ}}㎡
                                    </span>
                                </el-row>
                            </el-col>
                        </el-col>
                    </div>

                    <el-row>
                    </el-row>
                </el-card>
                <div class="TableDiv">
                    <el-table
                            :data="fwCList"
                            border
                            style="width: 100%">
                        <el-table-column
                                prop="xxxx"
                                label="自然层"
                                align="center"
                                width="100">
                            <template slot-scope="scope">
                                <el-row :class="`classC${scope.row.QSC}`">
                                    <span>{{scope.row.QSC}}</span>
                                </el-row>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="xxxx"
                                label="销售层"
                                align="center"
                                width="160">
                            <template slot-scope="scope">
                                <div class="lpbxxTd">
                                    <el-row class="cxx">
                                        {{scope.row.QSC}}
                                    </el-row>
                                    <el-row class="ctsxx">
                                        {{scope.row.CTS}}套/{{scope.row.CMJ}}㎡
                                    </el-row>
                                </div>
                            </template>
                        </el-table-column>
                        <template v-for="o in MaxRoomNum">
                            <el-table-column  prop=""  label="" width="190" >
                                <template slot-scope="scope">
                                    <div  class="lpbxxTd" :style="{background:scope.row['color'+o]}">
                                        <el-row class="cxx" :class="`classH${scope.row.QSC}`">
                                            <el-row>
                                                {{scope.row['f'+o]}}
                                            </el-row>
                                            <el-row class="ctsxx">
                                                {{scope.row['m'+o]}}
                                            </el-row>
                                        </el-row>
                                    </div>

                                </template>
                            </el-table-column>
                        </template>
                    </el-table>
                </div>
            </div>
        </el-main>
    </el-container>
</template>

<script>
    import {mapActions} from "vuex";

    export default {
        name: "lpbxx",
        data() {
            return {
                FLOORS:11,
                MaxRoomNum:8,
                MINFLOOR:1,
                MAXFLOOR:10,
                BUILDNO:'8号楼',
                BLDLOCATION:'禅城区东大街10号8号楼',
                PROJECTNAME:'阳光丽城',
                fwCList: Array(1).fill(""),
                /*fwCList: [{
                    "QSC": 10,
                    "CMJ": 582.63,
                    "CTS": 6,
                    "f1":"1",
                    "m1":"面积:101㎡",
                    "color1":"#B5F3D6",
                    "f2":"2",
                    "m2":"面积:101㎡",
                    "color2":"blue",
                    "f3":"3",
                    "m3":"面积:101㎡",
                }, {
                    "QSC": 9,
                    "CMJ": 719.05,
                    "CTS": 6,
                    "f1":"1",
                    "m1":"101",
                    "f2":"2",
                    "m2":"102",
                    "f3":"3",
                    "m3":"103",
                }, {
                    "QSC": 8,
                    "CMJ": 718.05,
                    "CTS": 6,
                    "f1":"1",
                    "m1":"101",
                    "f2":"2",
                    "m2":"102",
                    "f3":"3",
                    "m3":"103",
                }, {
                    "QSC": 7,
                    "CMJ": 717.05,
                    "CTS": 6,
                    "f1":"1",
                    "m1":"101",
                    "f2":"2",
                    "m2":"102",
                    "f3":"3",
                    "m3":"103",
                }, {
                    "QSC": 6,
                    "CMJ": 719.05,
                    "CTS": 6,
                    "f1":"1",
                    "m1":"101",
                    "f2":"2",
                    "m2":"102",
                    "f3":"3",
                    "m3":"103",
                }, {
                    "QSC": 5,
                    "CMJ": 719.05,
                    "CTS": 6
                }, {
                    "QSC": 4,
                    "CMJ": 719.05,
                    "CTS": 6
                }, {
                    "QSC": 3,
                    "CMJ": 719.1,
                    "CTS": 6
                }, {
                    "QSC": 2,
                    "CMJ": 702.98,
                    "CTS": 6
                }, {
                    "QSC": 1,
                    "CMJ": 710.14,
                    "CTS": 6
                }, {
                    "QSC": -1,
                    "CMJ": 762.67,
                    "CTS": 6
                }, {
                    "QSC": -2,
                    "CMJ": 724.81,
                    "CTS": 66
                }],*/
                /*fwCList: [{
                    QSC: '1',
                    CMJ:0,
                    CTS:0,
                }, {
                    QSC: '2',
                    CMJ:0,
                    CTS:0,
                },{
                    QSC: '3',
                    CMJ:0,
                    CTS:0,
                },{
                    QSC: '4',
                    CMJ:0,
                    CTS:0,
                },{
                    QSC: '5',
                    CMJ:0,
                    CTS:0,
                },{
                    QSC: '6',
                    CMJ:0,
                    CTS:0,
                },{
                    QSC: '7',
                    CMJ:0,
                    CTS:0,
                },{
                    QSC: '8',
                    CMJ:0,
                    CTS:0,
                },{
                    QSC: '9',
                    CMJ:0,
                    CTS:0,
                },{
                    QSC: '10',
                    CMJ:0,
                    CTS:0,
                }],*/
                floorList:{
                    MJ:'1726',
                    TS:'123',
                    ZZZH:'123EWDSSD2112',
                    ZZYXQ:'2020-12-12'
                },
                xmMap:{
                    XQMC:'颐和苑',
                    LH:'1号楼',
                },
                lpbLxList:[
                    {
                        FWTYPE: '已预售许可',
                        COLOR:'#B5F3D6',
                        TS:0,
                        MJ:0,
                    },
                    {
                        FWTYPE: '已网签',
                        COLOR:'#C1DBFF',
                        TS:0,
                        MJ:0,
                    },
                    {
                        FWTYPE: '已备案',
                        COLOR: "#FFE6C1",
                        TS:0,
                        MJ:0,
                    },
                    {
                        FWTYPE: '已查封',
                        COLOR: '#FFD0C1',
                        TS:0,
                        MJ:0,
                    },
                    {
                        FWTYPE: '不可网签',
                        COLOR: '#E9EDF3',
                        TS:0,
                        MJ:0,
                    },
                ],
                lpxxList:{

                },
            }
        },
        methods: {
            ...mapActions([
                'HtxxSelect',
            ]),
            warnMessage(obj) {
                this.$alert(obj, '温馨提示', {
                    confirmButtonText: '确定',
                });
            },
            //获取楼盘表信息
            handleUserList() {
                this.HtxxSelect({_module:'TT',_method:'getFwLpb',"buildid": this.$route.query.roomid}).then((res) => {  //这是从本地请求的数据接口，
                    this.floorList = res._result.floorList;
                    this.xmMap=res._result.xmMap;
                    this.lpbLxList=res._result.lpbLxList;
                    this.fwCList=res._result.fwCList;
                    //获得层信息
                    this.MaxRoomNum=res._result.fwCMap.MAXROOMNUM;
                    /*
                    this.MinRoomNum =res._result.fwCMap.MINC;
                    this.MAXFLOOR = res._result.fwCMap.MAXC;*/
                    /*if(this.MinRoomNum>0){
                        this.MinRoomNum=0;
                    }
                    if(this.MinRoomNum<0&& this.MAXFLOOR>0){
                        this.MAXFLOOR=this.MAXFLOOR-this.MinRoomNum;
                    }else if(this.MinRoomNum<0&& this.MinRoomNum<0){
                        this.MAXFLOOR=this.MAXFLOOR-this.MinRoomNum+1;
                    }*/
                    //this.MaxRoomNum=this.fwCList.length;
                    /*var qsc=0;
                    var sh = 0;
                    var fh="";
                    var className="";
                    var mj="";*/
                    /*循环渲染楼盘表数据*/
                    /*if(res._result.fwList!=null){
                        for(let i=0;i<res._result.fwList.length;i++){
                            qsc= res._result.fwList[i].QSC;
                            sh = res._result.fwList[i].SH;
                            fh = res._result.fwList[i].FH;
                            mj = res._result.fwList[i].MJ;
                            let dqc = qsc-this.MinRoomNum;
                            if(qsc<0) {
                                className="class"+"_"+(this.MAXFLOOR-dqc)+"_"+sh;
                            }else{
                                className="class"+"_"+(this.MAXFLOOR-dqc+1)+"_"+sh;
                            }
                            let kk = "<span>"+fh+"</span><br/><span>面积:"+mj+"㎡</span>";
                            $("."+className).html(kk);
                            /!*设置颜色*!/
                            if(res._result.fwList[i].SFCF=="是"){
                                $("."+className).css("background","#FFD0C1");
                            }else if(res._result.fwList[i].SFBA=="是"){
                                $("."+className).css("background","#FFE6C1");
                            }else if(res._result.fwList[i].SFQY=="是"){
                                $("."+className).css("background","#C1DBFF");
                            }else if(res._result.fwList[i].SFXK=="是"){
                                $("."+className).css("background","#B5F3D6");
                            }else{
                                $("."+className).css("background","#E9EDF3");
                            }
                        }
                    }*/

                })
            },
        },
        created() {
            this.handleUserList();
        },
    }
</script>

<style scoped>
    @import "../assets/css/spf/lpbxx.css";
</style>